import AjaxRequest from './AjaxRequest.js';

class DitecProductNavigation
{

    constructor(debug=false)
    {
        this.debug = debug;
        this.productNavigationContainers = document.querySelectorAll('.product-nav');
        this.productCategories = document.querySelectorAll('.product-nav li[data-category]');
        if (!this.productCategories || !this.productNavigationContainers) {
            return;
        }
        this.init();
    }

    init()
    {
        for (const productCategory of this.productCategories) {
            const id = productCategory.getAttribute('data-category');
            const parentId = productCategory.getAttribute('data-parent-category');
            productCategory.addEventListener('mouseenter', () => {
                this.loadProductCategoryPreview(id, parentId);
                for (const a of productCategory.parentNode.querySelectorAll('a.-preloaded'))
                    a.classList.remove('-preloaded');
            });
            productCategory.addEventListener('click', (e) => {
                const subMenu = productCategory.querySelector('ul');
                if (null === subMenu || (productCategory.classList.contains('-hover') && 'A' === e.target.tagName)) return;
                e.preventDefault();
                productCategory.classList.toggle('-hover');
                for (const p of this.productCategories) if (p !== productCategory) p.classList.remove('-hover');
            });
        }

        this.preloadFirstProductCategoryPreviewWithinEachNavigationContainer();

        // If an overlay (= navigation container) disappears, also hide all previews:
        for (const productNavigationContainer of this.productNavigationContainers) {
            productNavigationContainer.addEventListener('hide', () => {
                setTimeout(() => {
                    this.preloadFirstProductCategoryPreviewWithinEachNavigationContainer();
                }, 1000);
            });
        }
    }

    /**
     * Preload the first product category preview within each navigation controller
     */
    preloadFirstProductCategoryPreviewWithinEachNavigationContainer()
    {
        for (const productCategory of this.productCategories) {
            const id = productCategory.getAttribute('data-category');
            const parentId = productCategory.getAttribute('data-parent-category');
            if (1 === parseInt(productCategory.getAttribute('data-preload-preview'))) {
                this.loadProductCategoryPreview(id, parentId);
                productCategory.querySelector('a').classList.add('-preloaded');
            }
        }
    }

    loadProductCategoryPreview(id, parentId)
    {
        const previewContainer = document.getElementById(`product-nav-${parentId}`).querySelector('.product-nav__preview');
        if (!previewContainer) {
            return;
        }
        if (this.showLoadedCategoryPreview(previewContainer, id)) {
            return;
        }
        previewContainer.classList.add('-loading');
        const ajaxRequest = new AjaxRequest({
            url: '/index.php?id=4&type=20210525',
            data: {
                userFunc: 'JungAgency\\Ditec\\Controller\\ProductController->productNavAction',
                uid: id, // uid of the category
            },
            callback: (response) => {
                if (!response) {
                    console.error('[DitecProductNavigation]', 'Could not load a category preview!');
                    return;
                }
                this.hideAllCategoryPreviews(previewContainer);
                const newCategoryPreview = document.createElement('div');
                newCategoryPreview.innerHTML = response;
                newCategoryPreview.classList.add('category-preview');
                newCategoryPreview.setAttribute('data-category-preview', id);
                previewContainer.appendChild(newCategoryPreview);
                previewContainer.classList.remove('-loading');
            }
        });
        ajaxRequest.send();
        this.debug && console.log('[DitecProductNavigation]', ajaxRequest.getPublicRequestUrl());
    }

    showLoadedCategoryPreview(previewContainer, categoryID)
    {
        const loadedCategoryPreview = previewContainer.querySelector(`div[data-category-preview="${categoryID}"]`);
        if (null === loadedCategoryPreview) {
            return false;
        }
        this.hideAllCategoryPreviews(previewContainer);
        loadedCategoryPreview.style.display = 'block';
        return true;
    }

    hideAllCategoryPreviews(previewContainer)
    {
        for (const categoryPreview of previewContainer.querySelectorAll('div[data-category-preview]')) {
            categoryPreview.style.display = 'none';
        }
    }

}

export default DitecProductNavigation;